import { render, staticRenderFns } from "./ImportApproval.vue?vue&type=template&id=dda2511e&scoped=true"
import script from "./ImportApproval.vue?vue&type=script&lang=js"
export * from "./ImportApproval.vue?vue&type=script&lang=js"
import style0 from "./ImportApproval.vue?vue&type=style&index=0&id=dda2511e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda2511e",
  null
  
)

export default component.exports